
export const szakacsgeri = {
  content: {
    hero: {
      title: "Szakács Geri",
      subtitle: "Singer-Songwriter"
    },
    biography: {
      title: "My Story"
    },
    services: {
      title: "Connect with My Music",
      subtitle: "Discover different ways to get closer to me and my music",
      explore: "Explore"
    },
    discography: {
      title: "Discography",
      tracks: "Tracks",
      listen: "Listen"
    },
    concerts: {
      title: "Concerts",
      subtitle: "Hearing music live is always a special experience. See when you can meet me at a concert.",
      buyTickets: "Buy Tickets",
      soldOut: "Sold Out",
      soon: "Coming Soon",
      noEvents: "There are currently no announced concerts. Follow me on social media to stay updated with the latest news!"
    },
    testimonials: {
      title: "What They Say About Me",
      subtitle: "Hear what fans say about my music",
      fan: "Fan"
    },
    video: {
      title: "Featured Video",
      subtitle: "Watch my latest music video and immerse yourself in my music"
    },
    spotify: {
      title: "Spotify Playlists",
      subtitle: "Listen to my selected songs and favorite music"
    },
    gallery: {
      title: "Gallery",
      subtitle: "Pictures from concerts and behind the scenes"
    },
    awards: {
      title: "Awards and Recognitions",
      subtitle: "Recognitions I've received throughout my music career"
    },
    influences: {
      title: "Influences and Instruments",
      subtitle: "Musical influences and instruments that have shaped my style",
      musicalInfluences: "Musical Influences",
      instruments: "Instruments"
    },
    press: {
      title: "Press Coverage",
      subtitle: "Selection of articles and interviews about me",
      readArticle: "Read Article"
    },
    quote: {
      byArtist: "Szakács Geri"
    },
    footer: {
      allRights: "All rights reserved.",
      contact: "Contact",
      follow: "Follow"
    }
  }
};
